import { StorageSerializers, useStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import {
  SidebarVariant,
  type SidebarVariantType,
} from '../components/Sidebar/Sidebar.types';

export const SIDEBAR_STORE_NAME = 'sidebar';

export const useSidebarStore = defineStore(SIDEBAR_STORE_NAME, () => {
  const collapsed = useStorage<boolean>('collapsed', false, localStorage, {
    serializer: StorageSerializers.boolean,
  });

  const variant = ref<SidebarVariantType>(SidebarVariant.Light);

  const toggleCollapse = () => {
    collapsed.value = !collapsed.value;
  };

  const setCollapsed = (isCollapsed: boolean) => {
    collapsed.value = isCollapsed;
  };

  const setVariant = (nextVariant: SidebarVariantType) => {
    variant.value = nextVariant;
  };

  return {
    toggleCollapse,
    setCollapsed,
    setVariant,
    collapsed,
    variant,
  };
});
